
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DiffProjects/DiffProjects.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DiffProjects.html');
        
        var script = require('./DiffProjects.ts').default;
        module.exports = require('./DiffProjects.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    